import { BaseApi } from './base.apis'

export class AreaFieldsApi extends BaseApi {}

export const areaFieldsApi = new AreaFieldsApi('/admin/areaFields')
